// src/app/router/AppRouter.jsx
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { VerifyEmailPage } from '../../core/auth/pages/VerifyEmailPage';
import { PublicOnlyRoute } from './PublicOnlyRoute';
import { ProtectedRoute } from './ProtectedRoute';
import { AppGate } from './AppGate';

import SignInPage from 'core/auth/pages/SignInPage';
import SignUpPage from 'core/auth/pages/SignUpPage';
import ForgotPasswordPage from 'core/auth/pages/ForgotPasswordPage';

import AppShellLayout from './AppShellLayout';

// Pilates
import PilatesDashboard from 'sectors/pilates/pages/PilatesDashboard';
import PilatesStaffPage from 'sectors/pilates/staff/pages/PilatesStaffPage';
import PilatesMembersPage from 'sectors/pilates/members/pages/PilatesMembersPage';
import PilatesSessionsPage from 'sectors/pilates/sessions/pages/PilatesSessionsPage';
import PilatesAccountingPage from 'sectors/pilates/accounting/pages/PilatesAccountingPage';
import PilatesSettingsPage from 'sectors/pilates/settings/pages/PilatesSettingsPage';
import ServicesPage from 'sectors/pilates/marketing/pages/ServicesPage';
import PilatesReportsPage from 'sectors/pilates/reports/PilatesReportsPage';

import { AdminOnlyRoute } from './AdminOnlyRoute';
import { ActivityLogs } from 'sectors/pilates/reports/activityLogs/ActivityLogs';
import StaffReportsPage from 'sectors/pilates/reports/staff/pages/StaffReportsPage';
import SmsManagementPage from 'sectors/pilates/sms/SmsManagementPage';
import RsvpPage from 'core/rsvp/RsvpPage';
import SubscriptionPlansPage from 'sectors/pilates/pages/SubscriptionPlansPage';
import ProfileOverview from 'sectors/pilates/profile';
import PayrollCalculatePage from 'sectors/pilates/accounting/components/payroll/pages/PayrollCalculatePage';

function AppHome() {
  return <div style={{ padding: 16 }}>App Home…</div>;
}

export function AppRouter() {
  return (
    <Routes>
      {/* ---------- PUBLIC ---------- */}
      <Route
        path="/sign-in"
        element={
          <PublicOnlyRoute>
            <SignInPage />
          </PublicOnlyRoute>
        }
      />
      <Route
        path="/sign-up"
        element={
          <PublicOnlyRoute>
            <SignUpPage />
          </PublicOnlyRoute>
        }
      />
      <Route
        path="/forgot-password"
        element={
          <PublicOnlyRoute>
            <ForgotPasswordPage />
          </PublicOnlyRoute>
        }
      />
      <Route
        path="/verify-email"
        element={
          <PublicOnlyRoute>
            <VerifyEmailPage />
          </PublicOnlyRoute>
        }
      />
      <Route path="/rsvp/:token" element={<RsvpPage />} />
      <Route path="/login" element={<Navigate to="/sign-in" replace />} />
      <Route path="/register" element={<Navigate to="/sign-up" replace />} />
      <Route path="*" element={<div style={{ padding: 24 }}>404 - Not Found</div>} />
      {/* ---------- APP (AUTH) ---------- */}
      <Route
        path="/app"
        element={
          <ProtectedRoute>
            <AppGate />
          </ProtectedRoute>
        }
      >
        {/* ✅ SHELL İÇİ */}
        <Route element={<AppShellLayout />}>
          <Route index element={<AppHome />} />

          {/* ---------------- PILATES ---------------- */}
          <Route path="pilates">
            <Route path="packages" element={<SubscriptionPlansPage />} />
            {/* ✅ admin olmayanlar dashboard'a düşmesin */}
            <Route index element={<Navigate to="sessions" replace />} />
            {/* herkes görebilir */}
            <Route path="sessions" element={<PilatesSessionsPage />} />
            <Route path="staff" element={<PilatesStaffPage />} />
            <Route path="members" element={<PilatesMembersPage />} />
            <Route path="services" element={<ServicesPage />} />
            <Route path="profile" element={<ProfileOverview />} /> {/* ✅ sadece OWNER/ADMIN */}
            <Route element={<AdminOnlyRoute />}>
              <Route path="dashboard" element={<PilatesDashboard />} />
              <Route path="accounting" element={<PilatesAccountingPage />} />
              <Route path="sms" element={<SmsManagementPage />} />
              <Route path="accounting/payroll/:staffId" element={<PayrollCalculatePage />} />{' '}
              <Route path="reports">
                <Route index element={<PilatesReportsPage />} />
                <Route path="company" element={<PilatesReportsPage />} />
                <Route path="members" element={<PilatesReportsPage />} />
                <Route path="logs" element={<ActivityLogs />} />
                {/* şimdilik diğerleri yoksa ekleme */}
                {/* <Route path="company" element={<CompanyReportsPage />} /> */}
                {/* <Route path="members" element={<MemberReportsPage />} /> */}
                <Route path="staff" element={<StaffReportsPage />} />
              </Route>
              <Route path="settings" element={<PilatesSettingsPage />} />
            </Route>
            {/* ✅ bilinmeyen pilates path -> sessions */}
            <Route path="*" element={<Navigate to="/app/pilates/sessions" replace />} />
          </Route>

          {/* shell içi bilinmeyen -> /app */}
          <Route path="*" element={<Navigate to="/app" replace />} />
        </Route>
      </Route>

      {/* ---------- ROOT FALLBACK ---------- */}
      <Route path="/" element={<Navigate to="/app" replace />} />
      <Route path="*" element={<Navigate to="/app" replace />} />
    </Routes>
  );
}
